import magicIcon from "../../../../assets/icons/magic_1.png";
export default function MagicContent() {
    return (
        <>
            <div className="msg_track">
                <p className="carpet-note">
                    <span>
                        <img className="image_good" src={magicIcon} alt="Magic 1" />
                    </span>{" "}
                    MADE FOR LOW-FUSS LIVING: BECAUSE YOUR CARPET SHOULD WORK WITH
                    YOUR LIFESTYLE, NOT AGAINST IT.
                </p>
            </div>

            <div className="msg_track-mlb-main" >
                <div className="msg_track-mlb">

                    <div>
                        <img
                            className="image_good" src={magicIcon} alt="Magic 1" />
                    </div>{" "}
                    <div>

                        MADE FOR LOW-FUSS LIVING: BECAUSE YOUR CARPET SHOULD WORK WITH
                        YOUR LIFESTYLE, NOT AGAINST IT.
                    </div>
                </div>
            </div>
        </>
    );
}
